import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { CTAButton } from '../ui/CTAButton';
import { ZapIcon, RouteIcon, TargetIcon, CheckCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full py-20 md:py-32 px-5" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        {/* Formula headline */}
        <ScrollReveal data-id="element-160">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-6" data-id="element-161">
            La solución: la <span className="text-accent" data-id="element-162">Fórmula 1–3–1</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-163">
          <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mb-12" data-id="element-164">
            No necesitas "talento especial".{' '}
            <span className="text-white font-bold" data-id="element-165">
              Necesitas un sistema para fabricar ganchos que se sientan
              naturales en tu voz.
            </span>
          </p>
        </ScrollReveal>

        {/* Formula visual */}
        <ScrollReveal delay={0.15} data-id="element-166">
          <div className="relative" data-id="element-167">
            {/* Connecting line */}
            <div className="absolute left-[27px] md:left-[31px] top-0 bottom-0 w-px bg-gradient-to-b from-accent via-accent-light to-accent hidden md:block" data-id="element-168" />

            <div className="space-y-6" data-id="element-169">
              {/* 1 Golpe */}
              <div className="relative flex gap-5 md:gap-6 items-start" data-id="element-170">
                <div className="relative z-10 flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent/15 border border-accent/30 flex items-center justify-center" data-id="element-171">
                  <ZapIcon className="w-6 h-6 md:w-7 md:h-7 text-accent" data-id="element-172" />
                </div>
                <div className="pt-1" data-id="element-173">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-174">
                    <span className="text-3xl md:text-4xl font-extrabold text-accent" data-id="element-175">
                      1
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-white" data-id="element-176">
                      Golpe
                    </span>
                  </div>
                  <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-177">
                    Tensión inmediata{' '}
                    <span className="text-neutral-500" data-id="element-178">
                      (sin gritar, sin cringe).
                    </span>
                  </p>
                </div>
              </div>

              {/* 3 Rutas */}
              <div className="relative flex gap-5 md:gap-6 items-start" data-id="element-179">
                <div className="relative z-10 flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-light/10 border border-accent-light/30 flex items-center justify-center" data-id="element-180">
                  <RouteIcon className="w-6 h-6 md:w-7 md:h-7 text-accent-light" data-id="element-181" />
                </div>
                <div className="pt-1" data-id="element-182">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-183">
                    <span className="text-3xl md:text-4xl font-extrabold text-accent-light" data-id="element-184">
                      3
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-white" data-id="element-185">
                      Rutas
                    </span>
                  </div>
                  <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-186">
                    Eliges una:{' '}
                    <span className="text-white font-semibold" data-id="element-187">Curiosidad</span>{' '}
                    /{' '}
                    <span className="text-white font-semibold" data-id="element-188">Beneficio</span>{' '}
                    /{' '}
                    <span className="text-white font-semibold" data-id="element-189">Contraste</span>.
                  </p>
                </div>
              </div>

              {/* 1 Remate */}
              <div className="relative flex gap-5 md:gap-6 items-start" data-id="element-190">
                <div className="relative z-10 flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent/15 border border-accent/30 flex items-center justify-center" data-id="element-191">
                  <TargetIcon className="w-6 h-6 md:w-7 md:h-7 text-accent" data-id="element-192" />
                </div>
                <div className="pt-1" data-id="element-193">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-194">
                    <span className="text-3xl md:text-4xl font-extrabold text-accent" data-id="element-195">
                      1
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-white" data-id="element-196">
                      Remate
                    </span>
                  </div>
                  <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-197">
                    Micro-promesa para empujar al cuerpo del video.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-198">
          <p className="mt-10 text-lg md:text-xl text-neutral-300 leading-relaxed" data-id="element-199">
            Esto convierte el gancho en algo{' '}
            <span className="text-white font-bold" data-id="element-200">repetible</span>, no algo
            "inspiracional".
          </p>
        </ScrollReveal>

        {/* Divider */}
        <div className="my-16 md:my-24 h-px bg-gradient-to-r from-transparent via-border to-transparent" data-id="element-201" />

        {/* What's included */}
        <ScrollReveal data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-3" data-id="element-203">
            Qué incluye <span className="text-accent" data-id="element-204">HOOK ARSENAL</span>
          </h2>
          <p className="text-lg text-neutral-400 mb-10" data-id="element-205">
            Esto no es un curso eterno.{' '}
            <span className="text-white font-semibold" data-id="element-206">Es un arsenal.</span>
          </p>
        </ScrollReveal>

        <div className="space-y-4" data-id="element-207">
          <ScrollReveal delay={0.05} data-id="element-208">
            <div className="flex gap-4 items-start" data-id="element-209">
              <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-210" />
              <p className="text-lg text-neutral-200 leading-relaxed" data-id="element-211">
                <span className="text-white font-bold" data-id="element-212">
                  200 ganchos en Español MX
                </span>{' '}
                (listos para copiar y ajustar a tu nicho)
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.1} data-id="element-213">
            <div className="flex gap-4 items-start" data-id="element-214">
              <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-215" />
              <p className="text-lg text-neutral-200 leading-relaxed" data-id="element-216">
                <span className="text-white font-bold" data-id="element-217">
                  Plantillas de apertura
                </span>{' '}
                para cuando te quedas en blanco
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.15} data-id="element-218">
            <div className="flex gap-4 items-start" data-id="element-219">
              <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-220" />
              <p className="text-lg text-neutral-200 leading-relaxed" data-id="element-221">
                <span className="text-white font-bold" data-id="element-222">Mini guía</span> para
                elegir la ruta correcta (Curiosidad/Beneficio/Contraste)
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-223">
            <div className="flex gap-4 items-start" data-id="element-224">
              <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-225" />
              <p className="text-lg text-neutral-200 leading-relaxed" data-id="element-226">
                <span className="text-white font-bold" data-id="element-227">Selector rápido:</span>{' '}
                qué gancho usar según tu tipo de Reel
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.25} data-id="element-228">
            <div className="flex gap-4 items-start" data-id="element-229">
              <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-230" />
              <p className="text-lg text-neutral-200 leading-relaxed" data-id="element-231">
                <span className="text-white font-bold" data-id="element-232">Checklist</span> para no
                matar el primer segundo (visual + texto + ritmo)
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.3} data-id="element-233">
            <div className="flex gap-4 items-start" data-id="element-234">
              <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-235" />
              <p className="text-lg text-neutral-200 leading-relaxed" data-id="element-236">
                <span className="text-white font-bold" data-id="element-237">Antes/Después:</span>{' '}
                ejemplos de ganchos débiles reescritos a ganchos que detienen
              </p>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={0.35} data-id="element-238">
          <div className="mt-12 flex justify-center" data-id="element-239">
            <CTAButton data-id="element-240">Quiero HOOK ARSENAL</CTAButton>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}